import { Grid, Typography } from '@mui/material';
import React from 'react';

const Relatorios = () => {
  return (
    <Grid style={{  justifyContent: 'center', alignItems: 'center', width: '100%', height: '100vh', overflow: 'hidden' }}>
      <Typography  style={{ textAlign: 'center', paddingTop: '2em', fontSize: '2em', fontWeight: '600' }}>Relatorio</Typography>
      <Grid style={{ height: '100%', width: '100%', overflow: 'hidden', position: 'relative', justifyContent: 'center', display: 'flex' }}>

        <iframe 
          width="105%" 
          height="1000" 
          src="https://cnm.org.br/eventos" 
          frameBorder="0" 
          style={{ border: '0', position: 'absolute', marginTop: "-150px" }} 
          allowFullScreen 
          sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        ></iframe>
      </Grid>
    </Grid>
  );
};

export default Relatorios;
